module.exports = __webpack_public_path__ + "img/plus.2d8dfd92.svg";